const LOAD_DATA_MASTER_CANDIDATE_PATHWAY           = 'LOAD_DATA_MASTER_CANDIDATE_PATHWAY'
const LOAD_DATA_MASTER_CANDIDATE_PATHWAY_SUCCESS   = 'LOAD_DATA_MASTER_CANDIDATE_PATHWAY_SUCCESS'
const LOAD_DATA_MASTER_CANDIDATE_PATHWAY_FAILED    = 'LOAD_DATA_MASTER_CANDIDATE_PATHWAY_FAILED'
const UNMOUNT_DATA_MASTER_CANDIDATE_PATHWAY        = 'UNMOUNT_DATA_MASTER_CANDIDATE_PATHWAY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const masterCandidatePathwayReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_CANDIDATE_PATHWAY:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_MASTER_CANDIDATE_PATHWAY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_MASTER_CANDIDATE_PATHWAY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_MASTER_CANDIDATE_PATHWAY:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default masterCandidatePathwayReducer;